import React from 'react'
import { Grid, Typography, Divider, Box } from '@mui/material'
import '../../../styles/report.css'

/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "10",
    "Visible": "1",
    "Label": "Health Perception",
    "HelpText": "",
    "ComponentType":"KEY VALUE LIST FOUR"
    "Values": [
        {
            "Order": "10",
            "Label": "Excellent",
            "Distribution": "0"
        },
        {
            "Order": "20",
            "Label": "Very good",
            "Distribution": "0"
        },
        {
            "Order": "30",
            "Label": "Good",
            "Distribution": "0"
        },
        {
            "Order": "40",
            "Label": "Fair",
            "Distribution": "0"
        },
        {
            "Order": "50",
            "Label": "Poor",
            "Distribution": "0"
        }
    ]
}
*/

const KeyValueListFour = (props) => {
    const OrderedSections = [...props.component.Values].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    //const FilteredSections = OrderedSections.filter((a)=> { return a.Visible==='1' })

    const DisplayItem = ({ displayValues }) => {
        return (
            <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                <Grid container direction="row" alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                        <Typography variant="body2" align="right">{displayValues.Label}:</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="body2" align="left">{Math.floor(parseInt(displayValues.Distribution || displayValues.Value,0))}%</Typography>
                    </Grid>
                </Grid>
            </Box>
        )
    }

    return (
        <Grid item lg={4} md={4} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>

            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h5" align="center">{props.component.Label}</Typography>
                </Grid>
                <Grid item xs={12} m={1}>
                    <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                </Grid>
                {
                    OrderedSections && OrderedSections.map((displayValues, index) => {
                        return (
                            <Grid item xs={12}>
                                <DisplayItem displayValues={displayValues} key={"demographics" + index} />
                            </Grid>
                        )
                    })
                }
            </Grid>

        </Grid>
    )
}

export default KeyValueListFour